module.exports = __webpack_public_path__ + "static/joinus-7aba43193e575a4b4356e4332ade1925.png";